const loginInterval = setInterval(() => {
    const userDetails = window?.accountData?.user;
    if (userDetails) {
        console.log(userDetails)
        clearInterval(loginInterval)
        // window.open('/', '_self');
    }
}, 100);
